var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c("admin-breadcrumb", {
        attrs: {
          items: [{ text: "Listings", path: { name: "admin-listings" } }],
          name: _vm.listingName,
          "no-title": "",
        },
      }),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { lg: "4", md: "5" } },
                [
                  _c(
                    "admin-panel",
                    {
                      attrs: { "with-footer": "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "footer",
                            fn: function () {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "text-center" },
                                  [
                                    !_vm.listing.bids_count &&
                                    !_vm.listing.is_finished
                                      ? _c(
                                          "b-button",
                                          {
                                            attrs: { variant: "danger" },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.cancelListing.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Cancel Listing")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      [
                                        _vm._v("\n              Seller: "),
                                        _c(
                                          "b-link",
                                          {
                                            attrs: {
                                              to: {
                                                name: "admin-company",
                                                params: {
                                                  id: _vm.listing.company.id,
                                                },
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.listing.company.name)
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.listing.win
                                      ? [
                                          _vm._v("\n              Buyer: "),
                                          _c(
                                            "b-link",
                                            {
                                              attrs: {
                                                to: {
                                                  name: "admin-company",
                                                  params: {
                                                    id: _vm.listing.win.company
                                                      .id,
                                                  },
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.listing.win.company.name
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.listing.win.shipper
                                            ? [
                                                _c("br"),
                                                _vm._v("Shipper: "),
                                                _c(
                                                  "b-link",
                                                  {
                                                    attrs: {
                                                      to: {
                                                        name: "admin-shipper",
                                                        params: {
                                                          id: _vm.listing.win
                                                            .shipper.id,
                                                        },
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.listing.win.shipper
                                                          .name
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("div", [
                                            _c("br"),
                                            _vm._v(
                                              "Order ID: " +
                                                _vm._s(_vm.listing.win.id) +
                                                "\n              "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _c("br"),
                                            _vm._v(
                                              "Order Price: " +
                                                _vm._s(_vm.winPrice) +
                                                "\n              "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _vm.listing.win.is_buy_now
                                            ? [
                                                _c("br"),
                                                _vm._v(
                                                  'Won with "buy now"\n              '
                                                ),
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.listing.is_from_buyer_request
                                            ? [
                                                _c("br"),
                                                _vm._v(
                                                  "Made from buyer request\n              "
                                                ),
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.listing.seller_fee
                                            ? _c(
                                                "div",
                                                [
                                                  _c("br"),
                                                  _vm._v(" "),
                                                  _c("strong", [
                                                    _vm._v("Seller Fees:"),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("admin-listing-fee-info", {
                                                    attrs: {
                                                      fee: _vm.listing
                                                        .seller_fee,
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.listing.buyer_fee
                                            ? _c(
                                                "div",
                                                [
                                                  _c("br"),
                                                  _vm._v(" "),
                                                  _c("strong", [
                                                    _vm._v("Buyer Fees:"),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("admin-listing-fee-info", {
                                                    attrs: {
                                                      fee: _vm.listing
                                                        .buyer_fee,
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        41706835
                      ),
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "text-center" },
                        [
                          _vm.listing.images
                            ? _c(
                                "b-carousel",
                                { attrs: { controls: "", fade: "" } },
                                _vm._l(
                                  _vm.listing.images,
                                  function (image, index) {
                                    return _c("b-carousel-slide", {
                                      key: index,
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "img",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "admin-listing-slide",
                                                  },
                                                  [
                                                    _c("b-img", {
                                                      staticClass:
                                                        "admin-listing-slide-img",
                                                      attrs: {
                                                        thumbnail: "",
                                                        center: "",
                                                        "fluid-grow": "",
                                                        src: image.url,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    })
                                  }
                                ),
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "h4",
                            { staticClass: "card-title mt-3" },
                            [
                              _vm.listing.is_promoted
                                ? _c("b-icon-star-fill", {
                                    attrs: { title: "Featured Listing" },
                                  })
                                : _vm._e(),
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.listingName) +
                                  "\n          "
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.listing.company
                            ? _c("h5", { staticClass: "card-subtitle" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.listing.inventory_value +
                                      " " +
                                      _vm.listing.inventory_unit
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.listing.company
                            ? _c("h6", { staticClass: "card-subtitle" }, [
                                _vm._v(_vm._s(_vm.listing.company.name)),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("admin-listing-status-badge", {
                            attrs: { listing: _vm.listing },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { lg: "8", md: "7" } },
                [
                  _c(
                    "admin-panel",
                    {
                      attrs: {
                        "sub-title": "Listing Information",
                        "second-body": !!_vm.listing.win,
                      },
                      scopedSlots: _vm._u(
                        [
                          !!_vm.listing.win
                            ? {
                                key: "second-body",
                                fn: function () {
                                  return [
                                    _c("strong", [_vm._v("Reviews")]),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      { staticClass: "my-3" },
                                      [
                                        _c("b-form-checkbox-group", {
                                          attrs: {
                                            options: [
                                              {
                                                text: "Reviews Opened",
                                                value: true,
                                              },
                                            ],
                                            size: "lg",
                                            switches: "",
                                          },
                                          on: { change: _vm.toggleOpenReviews },
                                          model: {
                                            value: _vm.reviews_opened,
                                            callback: function ($$v) {
                                              _vm.reviews_opened = $$v
                                            },
                                            expression: "reviews_opened",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "mt-3" },
                                      [
                                        _c(
                                          "b-tabs",
                                          {
                                            attrs: {
                                              "content-class": "p-3 bg-light",
                                              "nav-class":
                                                "font-weight-bold text-uppercase text-danger",
                                              fill: "",
                                            },
                                          },
                                          [
                                            _c(
                                              "b-tab",
                                              {
                                                attrs: {
                                                  title: "Seller Review",
                                                },
                                              },
                                              [
                                                _vm.listing.win.seller_review
                                                  ? [
                                                      _c(
                                                        "div",
                                                        { staticClass: "mb-2" },
                                                        [
                                                          _c("strong", [
                                                            _vm._v("Rating"),
                                                          ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        { staticClass: "mb-3" },
                                                        [
                                                          _c("star-rating", {
                                                            attrs: {
                                                              rating:
                                                                _vm.listing.win
                                                                  .seller_review
                                                                  .rating,
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        { staticClass: "mb-2" },
                                                        [
                                                          _c("strong", [
                                                            _vm._v("Comment"),
                                                          ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("div", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.listing.win
                                                              .seller_review
                                                              .comment
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  : [
                                                      _c("strong", [
                                                        _vm._v(
                                                          "Seller did not post review"
                                                        ),
                                                      ]),
                                                    ],
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-tab",
                                              {
                                                attrs: {
                                                  title: "Buyer Review",
                                                },
                                              },
                                              [
                                                _vm.listing.win.buyer_review
                                                  ? [
                                                      _c(
                                                        "div",
                                                        { staticClass: "mb-2" },
                                                        [
                                                          _c("strong", [
                                                            _vm._v("Rating"),
                                                          ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        { staticClass: "mb-3" },
                                                        [
                                                          _c("star-rating", {
                                                            attrs: {
                                                              rating:
                                                                _vm.listing.win
                                                                  .buyer_review
                                                                  .rating,
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        { staticClass: "mb-2" },
                                                        [
                                                          _c("strong", [
                                                            _vm._v("Comment"),
                                                          ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("div", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.listing.win
                                                              .buyer_review
                                                              .comment
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  : [
                                                      _c("strong", [
                                                        _vm._v(
                                                          "Buyer did not post review"
                                                        ),
                                                      ]),
                                                    ],
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              }
                            : null,
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _vm.listing.id
                        ? _c("p", [
                            _c("strong", [
                              _vm._v("Lot # " + _vm._s(_vm.listing.id)),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.listing.is_promoted
                        ? _c("p", [
                            _c("strong", [
                              _vm._v("This is a Featured Listing"),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.listing.description
                        ? _c("div", {
                            domProps: {
                              innerHTML: _vm._s(_vm.listing.description),
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("b-table", {
                        attrs: {
                          stacked: "",
                          bordered: "",
                          "table-class": "mb-0 mt-3",
                          items: _vm.tableItems,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }